
  <!-- <div class="card-header">
    <span class="cat__core__title">
      Authorisation Alert
    </span>
  </div>
  <div class="card-block datatable-card-block">
    <div class="row">
      <div class="col-md-12">
        <div class="margin-bottom-50">
          <p>
           You Dont have Permissions of this {{module}}
          </p>
        </div>
      </div>
    </div>
  </div> -->

  <div id="switchCompanyPage" class="text-center " style="padding-bottom: 10%; padding-top: 10%;">
    <div class="w-50 d-inline-block pt-5 pb-5 mt-5 mb-5">
        <h1 class="mb-4"><strong>Do you want to switch the company to check the {{module}} ?</strong></h1>
        <p class="mb-4">{{module}} Does not belongs to Your Loggedin Company, You have to switch the company to access this {{module}}</p>
        <a class="btn btn-link" href="{{dashboardURL}}"><b>Home</b></a>
        <!-- <button type="button" class="btn btn-sm btn-primary" (click)="switchcompany()">
          <i class="fa fa-check"></i>Switch Company</button>
        <button type="button" class="btn btn-sm btn-danger" (click)="closeWindow()">
          <i class="fa fa-times"></i>Cancel</button> -->
    </div>
</div>

<div id="unAuthAccess" class="text-center " style="padding-bottom: 10%; padding-top: 10%;">
  <div class="w-50 d-inline-block pt-5 pb-5 mt-5 mb-5">
      <h1 class="mb-4"><strong>Un-Authorized Access</strong></h1>
      <p class="mb-4">You Don't have Permission to access this Module</p>
      <a class="btn btn-link" href="{{dashboardURL}}"><b>Home</b></a>
      <!-- <button type="button" class="btn btn-sm btn-primary" (click)="switchcompany()">
        <i class="fa fa-check"></i>Switch Company</button>
      <button type="button" class="btn btn-sm btn-danger" (click)="closeWindow()">
        <i class="fa fa-times"></i>Cancel</button> -->
  </div>
</div>

